import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/useAuth';
import { OnboardingFlow } from './pages/OnboardingFlow';
import AdminDashboard from './pages/AdminDashboard';
import { AuthCallback } from './pages/AuthCallback';
import { LoadingSpinner } from './components/LoadingSpinner';
import { AutoSave } from './components/AutoSave';
import { isDeveloperMode, logDevMode } from './config/devMode';
import { Settings } from 'lucide-react';
import { isAdminType } from './lib/adminRoles';

function App() {
  const { isLoading, adminType } = useAuth();

  useEffect(() => {
    logDevMode();
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-scale-dark flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  const isAdmin = isAdminType(adminType);

  return (
    <>
      {isDeveloperMode && (
        <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-yellow-500 to-orange-500 text-black px-4 py-2 z-50 shadow-lg">
          <div className="max-w-7xl mx-auto flex items-center justify-center gap-2">
            <Settings className="w-5 h-5 animate-spin" style={{ animationDuration: '3s' }} />
            <span className="font-bold">DEVELOPER MODE</span>
            <span className="hidden sm:inline">- All forms are pre-populated for quick testing</span>
          </div>
        </div>
      )}
      <div className={isDeveloperMode ? 'pt-10' : ''}>
        <AutoSave />
        <Routes>
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/admin/*"
            element={
              isAdmin ? (
                <AdminDashboard />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route path="/*" element={<OnboardingFlow />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
